"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

exports.__esModule = true;
exports.dropdownPropTypes = void 0;

var _propTypes = require("prop-types");

var _propTypes2 = require("../Menu/propTypes");

var _constants = require("./constants");

var dropdownPropTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]).isRequired,
  data: _propTypes2.menuItemsPropType.isRequired,
  defaultHighlightedIndex: _propTypes.number,
  defaultIsOpen: _propTypes.bool,
  disabled: _propTypes.bool,
  highlightedIndex: _propTypes.number,
  id: _propTypes.string,
  isOpen: _propTypes.bool,
  item: _propTypes.func,
  itemKey: _propTypes.string,
  menu: _propTypes.func,
  modifiers: _propTypes.object,
  onClose: _propTypes.func,
  onOpen: _propTypes.func,
  placement: (0, _propTypes.oneOf)(Object.keys(_constants.PLACEMENT)),
  positionFixed: _propTypes.bool,
  usePortal: _propTypes.bool,
  wide: _propTypes.bool
};
exports.dropdownPropTypes = dropdownPropTypes;